<template>
  <div>
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1">
            <div class="circle circle_1"></div>
            <div class="circle circle_2"></div>
            <div class="circle circle_3"></div>
            <div class="section-content_1">
                <img class="section-content_1_img" src="@/assets/img/home/serverBanner.png" alt="">
            </div>
            <div class="section-content_middle">
                <div class="backOp_title">产品＆服务</div>
                <div class="backOp_content">“碳中枢”AI产品系列是面向全生命周期碳业务的专业化Agent应用工具</div>
            </div>
            <div class="backOp">
                <div class="backOp_view"></div>
            </div>
        </section>
        
        <!-- 第二屏 -->
        <section class="fullpage-section section-2">
          <vue-particles
            :particleOpacity="0.7"
            :particlesNumber="50"
            shapeType="circle"
            :particleSize="1"
            linesColor="#00CDFF"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push">
          </vue-particles>
          <div class="circle circle_4"></div>
          <div class="circle circle_5"></div>
          <div class="section-content_2">
            <!--碳盘查-->
            <template v-if="chooseIndex === 0">
                <template v-if="!isPlaying">
                    <div class="section-content_2_l">
                        <div class="section-content_2_l_view">
                            <div class="section-content_2_l_view_t">
                                <img class="section-content_2_l_view_t_img" src="@/assets/img/home/severPage_icon.png" alt="">
                                <div class="section-content_2_l_view_t_middle">
                                    <div class="section-content_2_l_view_t_middle_title">碳盘查Agent</div>
                                    <div class="section-content_2_l_view_t_middle_subtitle">—— 您的全域碳数据AI管家</div>
                                </div>
                                <div class="section-content_2_l_view_t_r" @click="playVideo">
                                    <img class="section-content_2_l_view_t_r_img" src="@/assets/img/home/severPage_play.png" alt="">
                                    <div class="section-content_2_l_view_t_r_text">查看视频</div>
                                </div>
                            </div>
                            <div class="section-content_2_l_view_b">
                                <div class="section-content_2_l_view_b_view">
                                    <div class="modalView_pop_l_view_b_buyAndTest_t noRightBorder">
                                        <div class="modalView_pop_l_view_b_buyAndTest_t_margin">
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_title">免费试用</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_tiele_text">了解碳盘查Agent如何完成您的任务</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">包含范围一、二</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">可核算1个业务场所</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">排放源数量 ≤ 20</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">3次报告体验</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_btn" @click="gotoChat('test')">现在申请</div>
                                        </div>
                                    </div>
                                    <div class="modalView_pop_l_view_b_buyAndTest_b modalView_pop_l_view_b_buyAndTest_t">
                                        <div class="modalView_pop_l_view_b_buyAndTest_t_margin">
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_title">选择服务</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_tiele_text">使用定制化碳盘查Agent完美解决需求</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">支持范围三核算</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">支持多业务场所</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">排放源数量可选</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">Pro版模型，更快速的响应，更精准的推理</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">新增自动取数功能，支持文件解析与系统对接</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_text">享受5次定制化报告生成服务</div>
                                            <!-- <div class="modalView_pop_l_view_b_buyAndTest_t_text">新增定制化的盘查报告</div> -->
                                            <div class="modalView_pop_l_view_b_buyAndTest_t_price">￥<span>9800</span>起</div>
                                            <div class="modalView_pop_l_view_b_buyAndTest_b_btn" @click="gotoChat()">立即购买</div>
                                        </div>
                                    </div>
                                </div>                        
                            </div>
                        </div>
                    </div>
                    <div class="section-content_2_m">
                        <div class="section-content_2_m_view section-content_2_m_t" @mouseenter="changeChooseIndex(1)">
                            <div class="section-content_2_m_title">碳足迹Agent</div>
                            <div class="section-content_2_m_text">点击申请试用</div>
                        </div>
                        <div class="section-content_2_m_view section-content_2_m_b" @mouseenter="changeChooseIndex(2)">
                            <div class="section-content_2_m_title">ESG报告<br>Agent</div>
                            <div class="section-content_2_m_text">2026年Q1</div>
                        </div>
                    </div>
                    <div class="section-content_2_r" @mouseenter="changeChooseIndex(3)">
                        <div class="section-content_2_r_title">定制服务</div>
                        <div class="section-content_2_r_text">基于企业个性化需求<br>1对1定制化服务</div>
                    </div>
                </template>               
                <div v-else class="modalView_pop_other">
                    <video
                        ref="videoPlayer" 
                        type="video/mp4"
                        autoplay 
                        controlsList="nodownload" 
                        oncontextmenu="return false;"
                        :src="videoSrc" 
                        controls
                        class="modalView_pop_other_video"
                    >
                    </video>
                    <span class="modalView_pop_close" @click="closeVideo">X</span>
                </div>

            </template>
            <!--碳足迹-->
            <template v-if="chooseIndex === 1">
                <div class="section-content_2_r background_1" @mouseenter="changeChooseIndex(0)">
                    <div class="section-content_2_r_title">碳盘查<br>Agent</div>
                    <div class="section-content_2_r_text">全球首款碳中和<br>专业Agent</div>
                </div>
                <div class="section-content_2_l_other">
                    <div class="section-content_2_l other">
                        <div class="section-content_2_l_view">
                            <div class="section-content_2_l_view_t section-content_2_l_view_t_other">
                                <img class="section-content_2_l_view_t_img marginRight_26" src="@/assets/img/home/severPage_icon.png" alt="">
                                <div class="section-content_2_l_view_t_middle">
                                    <div class="section-content_2_l_view_t_middle_title">碳足迹Agent</div>
                                    <div class="section-content_2_l_view_t_middle_subtitle">—— AI 驱动的零碳基因编辑器</div>
                                </div>
                            </div>
                            <div class="section-content_2_l_view_b flex_column">
                                <div class="flex_column_title marginBottom40 fontSize">碳足迹 Agent 是一款面向企业与产品全生命周期的智能碳足迹核算与减排决策平台，通过人工智能重构碳数据获取、计算建模与结果分析流程，让碳足迹管理从人工核算走向智能决策。</div>
                                <div class="flex_column_info">1.智能解析与合规计算</div>
                                <div class="flex_column_info_text marginBottom40">AI 实时解析多源数据，实现碳足迹计算的高精度与高效率。</div>
                                <div class="flex_column_info">2.热点识别与路径分析</div>
                                <div class="flex_column_info_text marginBottom40">基于智能算法，自动识别关键排放来源，系统化优化企业减排路径。</div>
                                <div class="flex_column_info">3.高效建模与排放测算</div>
                                <div class="flex_column_info_text marginBottom40">深度学习驱动工艺建模，实现复杂生产场景下更贴近真实排放的精准测算。</div>
                                <div class="flex_column_info">4.数据校验与结果溯源</div>
                                <div class="flex_column_info_text">AI 自动校验多模态数据并完成溯源标注，确保每一份碳足迹结果真实、可靠、可审计。</div>
                                <div class="flex_column_view">
                                    <div class="flex_column_btn" @click="gotoChat('test')">现在申请</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-content_2_l_bottom" @mouseenter="changeChooseIndex(2)">
                        <div class="section-content_2_m_title">ESG报告Agent</div>
                        <div class="section-content_2_m_text">2026年Q1</div>
                    </div>
                </div>
                <div class="section-content_2_r" @mouseenter="changeChooseIndex(3)">
                    <div class="section-content_2_r_title">定制服务</div>
                    <div class="section-content_2_r_text">基于企业个性化需求<br>1对1定制化服务</div>
                </div>
            </template>
            <!--ESG报告-->
            <template v-if="chooseIndex === 2">
                <div class="section-content_2_r background_1" @mouseenter="changeChooseIndex(0)">
                    <div class="section-content_2_r_title">碳盘查<br>Agent</div>
                    <div class="section-content_2_r_text">全球首款碳中和<br>专业Agent</div>
                </div>
                <div class="section-content_2_l_other">
                    <div class="section-content_2_l_bottom" @mouseenter="changeChooseIndex(1)">
                        <div class="section-content_2_m_title">碳足迹Agent</div>
                        <div class="section-content_2_m_text">点击申请试用</div>
                    </div>
                    <div class="section-content_2_l other">
                        <div class="section-content_2_l_view">
                            <div class="section-content_2_l_view_t section-content_2_l_view_t_other">
                                <img class="section-content_2_l_view_t_img marginRight_26" src="@/assets/img/home/severPage_icon.png" alt="">
                                <div class="section-content_2_l_view_t_middle">
                                    <div class="section-content_2_l_view_t_middle_title">ESG报告Agent</div>
                                    <div class="section-content_2_l_view_t_middle_subtitle">—— 您的战略级ESG智能引擎 </div>
                                </div>
                            </div>
                            <div class="section-content_2_l_view_b flex_column">
                                <div class="flex_column_other_info textIndent46 marginTop24">1.政策洞察</div>
                                <div class="flex_column_other_info_text marginBottom40">实时追踪国内外 ESG 法规与标准差异，智能诊断ESG风险与机遇</div>
                                <div class="flex_column_other_info textIndent46">2.多源融合</div>
                                <div class="flex_column_other_info_text marginBottom40">接入财务/生产/供应链等多元数据，AI驱动数据校验，保障数据可靠性</div>
                                <div class="flex_column_other_info textIndent46">3.一键产出</div>
                                <div class="flex_column_other_info_text marginBottom40">投资者报告、董事会简报、可持续发展报告输出</div>
                                <div class="flex_column_other_info textIndent46">4.应用成效</div>
                                <div class="flex_column_other_info_text">开启“ESG即服务”模式，显著降低披露成本、压缩周期、提升投资者与利益相关方信任度</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="section-content_2_l">
                    <div class="section-content_2_l_view">
                        <div class="section-content_2_l_view_t section-content_2_l_view_t_other">
                            <img class="section-content_2_l_view_t_img marginRight_26" src="@/assets/img/home/severPage_icon.png" alt="">
                            <div class="section-content_2_l_view_t_middle">
                                <div class="section-content_2_l_view_t_middle_title">ESG报告Agent</div>
                                <div class="section-content_2_l_view_t_middle_subtitle">—— 颠覆性的碳盘查服务</div>
                            </div>
                        </div>
                        <div class="section-content_2_l_view_b flex_column">
                            <div class="flex_column_other_info textIndent46 marginTop24">1.政策洞察</div>
                            <div class="flex_column_other_info_text marginBottom40">实时追踪国内外 ESG 法规与标准差异，智能诊断ESG风险与机遇</div>
                            <div class="flex_column_other_info textIndent46">2.多源融合</div>
                            <div class="flex_column_other_info_text marginBottom40">接入财务/生产/供应链等多元数据，AI驱动数据校验，保障数据可靠性</div>
                            <div class="flex_column_other_info textIndent46">3.一键产出</div>
                            <div class="flex_column_other_info_text marginBottom40">投资者报告、董事会简报、可持续发展报告输出</div>
                            <div class="flex_column_other_info textIndent46">4.应用成效</div>
                            <div class="flex_column_other_info_text">开启“ESG即服务”模式，显著降低披露成本、压缩周期、提升投资者与利益相关方信任度</div>
                        </div>
                    </div>
                </div> -->
                <div class="section-content_2_r" @mouseenter="changeChooseIndex(3)">
                    <div class="section-content_2_r_title">定制服务</div>
                    <div class="section-content_2_r_text">基于企业个性化需求<br>1对1定制化服务</div>
                </div>
            </template>
            <!--定制服务-->
            <template v-if="chooseIndex === 3">
                 <div class="section-content_2_r background_1" @mouseenter="changeChooseIndex(0)">
                    <div class="section-content_2_r_title">碳盘查<br>Agent</div>
                    <div class="section-content_2_r_text">全球首款碳中和<br>专业Agent</div>
                </div>
                <div class="section-content_2_m">
                    <div class="section-content_2_m_view section-content_2_m_t" @mouseenter="changeChooseIndex(1)">
                        <div class="section-content_2_m_title">碳足迹Agent</div>
                        <div class="section-content_2_m_text">点击申请试用</div>
                    </div>
                    <div class="section-content_2_m_view section-content_2_m_b" @mouseenter="changeChooseIndex(2)">
                        <div class="section-content_2_m_title">ESG报告<br>Agent</div>
                        <div class="section-content_2_m_text">2026年Q1</div>
                    </div>
                </div>
                <div class="section-content_2_l">
                    <div class="section-content_2_l_view">
                        <div class="section-content_2_l_view_t section-content_2_l_view_t_other">
                            <img class="section-content_2_l_view_t_img marginRight_26" src="@/assets/img/home/severPage_icon.png" alt="">
                            <div class="section-content_2_l_view_t_middle">
                                <div class="section-content_2_l_view_t_middle_title">定制服务</div>
                                <div class="section-content_2_l_view_t_middle_subtitle">—— 深度业务适配的定制化服务</div>
                            </div>
                        </div>
                        <div class="section-content_2_l_view_b flex_column">
                        <div class="flex_column_title marginBottom40">为满足企业多元化需求，我们提供灵活多样化的定制化解决方案：</div>
                        <div class="flex_column_info">1.模型定制服务</div>
                        <div class="flex_column_info_text marginBottom40">基于中碳“碳芯”大模型，深度融合行业数据、客户私域数据，结合需求实现定制化开发</div>
                        <div class="flex_column_info">2.AI Agent定制化服务</div>
                        <div class="flex_column_info_text marginBottom40">深度适配合规监管、供应链披露、个性化披露等特定流程</div>
                        <div class="flex_column_info">3.私有化服务</div>
                        <div class="flex_column_info_text marginBottom40">支持产品私有化部署，通过API深度集成用户系统，最大限度保障数据安全与配置灵活性</div>
                        <div class="flex_column_info">4.全生命周期碳管理服务</div>
                        <div class="flex_column_info_text marginBottom40">
                            由资深专家团队提供「AI工具+咨询服务」双轮驱动服务：<br>
                            • 可持续战略规划：零碳园区设计、ESG治理体系搭建、减碳路径规划等<br>
                            • 可持续资产增值：碳资产开发与交易策略、绿色金融产品对接、CCER/VCS项目全周期管理
                        </div>
                    </div>    
                    </div>
                </div>
            </template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 2, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      userInput: "",
      carouselIndex: 0, // 轮播当前索引
      carouselInterval: null, // 轮播定时器
      chooseIndex: 0, // 选择的服务索引
      videoSrc: require('@/assets/img/home/video.mp4'),
      videoPlayer: null, // 视频元素引用
      isPlaying: false, // 是否正在播放视频
      isAnimating: false, // 是否正在动画中
      prevChooseIndex: 0, // 上一次选择的索引
    };
  },
  beforeDestroy() {
    // 移除触摸板支持
    this.removeTrackpadSupport();
  },
  methods: {
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
        // 监听触摸板手势
        document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
        document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
        // 如果正在滚动中，则忽略后续滚轮事件
        if (this.isScrolling) return;

        // 对于非第三屏，阻止默认行为并处理全屏切换
        e.preventDefault();

        // 全屏切换逻辑
        if (e.deltaY > 0) {
            this.nextSection();
        } else {
            this.prevSection();
        }
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
        if (this.currentIndex < this.sections - 1) {
            this.startScroll(this.currentIndex + 1);
        }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
        if (this.currentIndex > 0) {
            this.startScroll(this.currentIndex - 1);
        }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
        this.isScrolling = true;
        this.currentIndex = index;
        
        // 滚动动画结束后重置状态
        setTimeout(() => {
            this.isScrolling = false;
        }, this.transitionDuration);
    },

    // 播放视频并进入全屏
    async playVideo() {
        this.isPlaying = true;
        try {
            // 等待DOM更新
            await this.$nextTick();
            const video = this.$refs.videoPlayer;
            // 开始播放视频
            await video.play();
        } catch (error) {
            console.error('Error playing video:', error);
            this.isPlaying = false;
        }
    },

    // 关闭视频并退出全屏
    closeVideo() {
        this.isPlaying = false; // 关闭视频 
    },

    gotoChat(v){
        if(v){
            const params = {
                is_trial: true
            };
            const jsonParams = JSON.stringify(params);
            const encodedParams = btoa(jsonParams);
            const targetUrl = `https://ai.carbonneutrality-group.com:51443/chat-app/?params=${encodeURIComponent(encodedParams)}`;

            window.location.href = targetUrl;
        }else{
            window.open('https://ai.carbonneutrality-group.com:51443/chat-app/')
        }
    },

    changeChooseIndex(index) {
      if (this.isAnimating || index === this.chooseIndex) return;
      this.prevChooseIndex = this.chooseIndex;
      this.isAnimating = true;
      this.chooseIndex = index;
      setTimeout(() => {
        this.isAnimating = false;
      }, 600);
    },
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

/* 各屏背景色 */
.section-1 {
    position: relative;

    .circle {
        position: absolute;
        background: rgba(0, 192, 255, 0.67);
        box-shadow: 0 0 700px 300px rgba(0, 192, 255, 0.2);
        backdrop-filter: blur(758.2999877929688px);
        z-index: 3;
    }

    .circle_1 {
        top: 400px;
        left: 15%;
    }

    .circle_2 {
        top: 400px;
        right: 15%;
    }

    .circle_3 {
        top: 400px;
        left: 50%;
        box-shadow: 0 0 700px 300px rgba(0, 192, 255, 0.09);
    }

    .section-content_middle{
        z-index: 4;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: calc(100vh * 245 / 1080);

        .backOp_title{
            font-size: 100px;
            font-weight: 700;
            font-family:'Inter', sans-serif;
            color: rgba(0, 95, 126, 1);
            line-height: 100%;
            letter-spacing: 24px;
            text-align: center;
        }

        .backOp_content{
            font-size: 24px;
            font-weight: 300;
            font-family:'Inter', sans-serif;
            color: rgba(0, 95, 126, 1);
            line-height: 100%;
            letter-spacing: 2px;
            margin-top: 20px;
            text-align: center;
        }
    }

    .backOp{
        z-index: 2;
        background: linear-gradient(0deg, rgba(30, 134, 168, 0.5) 0%, rgba(5, 183, 241, 0.1) 63.46%, rgba(0, 192, 255, 0) 100%);
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: calc(100vh * 304 / 1080);
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .backOp_view{
            width: calc(100vw * 1373px / 1920px);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 3;
            flex-direction: column;
            background: url('../../assets/img/home/serverBanner_other.png') no-repeat;
            background-size: 100% 100%;
        }
        
    }

    .section-content_1{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;

        .section-content_1_img{
          width: calc(100vw * 1375px / 1920px);
          height: calc(100vh * 618px / 1080px);
          position: absolute;
          top: calc(100vh * 135px / 1080px);
        }
    }
}

.section-2 {
  position: relative;
  top:0;
  left:0;

    .circle_4 {
        position: absolute;
        top: 400px;
        left: 19%;
        background: rgba(0, 192, 255, 0.39);
        box-shadow: 0 0 700px 300px rgba(0, 192, 255, 0.39);
        backdrop-filter: blur(758px);
    }

    .circle_5 {
        position: absolute;
        top: 650px;
        right: 19%;
        background: rgba(0, 192, 255, 0.42);
        backdrop-filter: blur(314px);
        box-shadow: 0 0 700px 300px rgba(0, 192, 255, 0.42);
    }

  .section-content_2{
    position: absolute;
    top: calc(100vh * 195px / 1080px);
    left: calc(100vw * 120px / 1920px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(100vh * 800 / 1080);
    width: calc(100vw - 13%);

    .section-content_2_l{
        // width: 52.69%;
        width: 51.19%;
        height: 100%;
        background: linear-gradient(180deg, #00CDFF 0%, #000000 100%);
        border: 3px solid rgba(123, 229, 255, 1);
        border-radius: 50px;
        box-shadow: 0px -41px 100.5px 0px rgba(0, 205, 255, 1) inset;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .section-content_2_l_view{
            width:90.91%;
            height:100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;

            .section-content_2_l_view_t{
                width: 100%;
                height: 22.73%;
                border-bottom: 1px solid rgba(255, 255, 255, 1);
                display: flex;
                justify-content: space-between;
                align-items: center;

                .section-content_2_l_view_t_img{
                    width: 85px;
                    height: 87px;
                    margin-bottom: -20px;
                }

                .marginRight_26{
                    margin-right: 26px;
                }

                .section-content_2_l_view_t_middle{
                    display: flex;
                    flex-direction: column;
                    height: 87px;
                    justify-content: end;
                    font-family:'Inter', sans-serif;
                    color: rgba(255, 255, 255, 1);
                    margin-top: 40px;

                    .section-content_2_l_view_t_middle_title{
                        font-size: 48px;
                        font-weight: 700;
                        line-height: 48px;
                    }

                    .section-content_2_l_view_t_middle_subtitle{
                        font-size: 28px;
                        font-weight: 400;
                    }
                }

                .section-content_2_l_view_t_r{
                    display: flex;
                    margin-left:100px;
                    align-items: flex-end;
                    height: 100%;
                    margin-bottom: 30px;

                    .section-content_2_l_view_t_r_img{
                        width: 80px;
                        height: 30px;
                        cursor: pointer;
                    }

                    .section-content_2_l_view_t_r_text{
                        font-size: 24px;
                        font-weight: 300;
                        margin-left: 30px;
                        color: rgba(255, 255, 255, 1);
                    }
                }
            }

            .section-content_2_l_view_t_other{
                justify-content: flex-start;
            }

            .section-content_2_l_view_b{
                width: 100%;
                height: 77.14%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                border-radius: 20px;

                .section-content_2_l_view_b_view{
                    width: 100%;
                    margin: 2.42% auto 6.375%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 90.55%;
                    background: rgba(255, 255, 255, 0.15);
                    border-radius: 20px;

                    .modalView_pop_l_view_b_buyAndTest_t{
                        width: calc(100vw * 433 / 1920);
                        height: 100%;
                        background: rgba(255, 255, 255, 0.15);
                        backdrop-filter: blur(12px);
                        box-shadow: 
                            0px 0px 22px 0px rgba(242, 242, 242, 0.5) inset,
                            0px 0px 0px 1px rgba(153, 153, 153, 1) inset,
                            -2px -2px 1px -2px rgba(179, 179, 179, 1) inset,
                            2px 2px 1px -2px rgba(179, 179, 179, 1) inset,
                            3px 3px 0.5px -3.5px rgba(255, 255, 255, 0.5) inset;
                        border-top-left-radius: 20px;
                        border-bottom-left-radius: 20px;                   

                        .modalView_pop_l_view_b_buyAndTest_t_margin{
                            margin: 5.49% 0px 2.38% 7.88%;
                            min-height: 90.55%;
                            height: 90.55%;

                            .modalView_pop_l_view_b_buyAndTest_t_title{
                                font-size: 36px;
                                font-weight: 700;
                                color: rgba(255, 255, 255, 1);
                                line-height: 36px;
                            }

                            .modalView_pop_l_view_b_buyAndTest_t_price{
                                font-size: 20px;
                                color: rgba(255, 255, 255, 1);
                                height: 48px;
                                line-height: 25px;
                                font-family: Inter;
                                margin-top: 10.62%;

                                span{
                                    font-weight: 700;
                                    font-size: 32px;
                                }
                            }

                            .modalView_pop_l_view_b_buyAndTest_t_tiele_text{
                                font-size: 24px;
                                font-weight: 400;
                                color: rgba(255, 255, 255, 1);
                                margin-top: 5.49%;
                                margin-bottom: 4.21%;
                                line-height: 26px;
                                width: 330px;
                            }

                            .marginBottom{
                                margin-bottom: 23px!important;
                            }

                            .modalView_pop_l_view_b_buyAndTest_t_text{
                                font-size: 18px;
                                font-weight: 400;
                                color: rgba(255, 255, 255, 1);
                                position: relative;
                                line-height: 26px;
                                margin-left: 10px;
                            }

                            .modalView_pop_l_view_b_buyAndTest_t_text::before{
                                content: "•"; /* 圆点字符 */
                                position: absolute;
                                left: -10px;
                                top: 50%;
                                transform: translateY(-50%);
                                color: #fff; /* 圆点颜色 */
                                font-size: 16px; /* 圆点大小 */
                                line-height: 1;
                            }

                            .modalView_pop_l_view_b_buyAndTest_t_btn{
                                width: calc(100vw * 170 / 1920);
                                height: calc(100vh * 60 / 1080);
                                color: rgba(255, 255, 255, 1);
                                border: 1px solid rgba(255, 255, 255, 1);
                                font-size: 24px;
                                font-weight: 300;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                margin-top: 45.52%;
                                border-radius: 50px;
                                letter-spacing: 5px;
                            }

                            .modalView_pop_l_view_b_buyAndTest_b_btn{
                                width: calc(100vw * 170 / 1920);
                                height: calc(100vh * 60 / 1080);
                                border-radius: 50px;
                                color: rgba(255, 255, 255, 1);
                                border: 1px solid rgba(255, 255, 255, 1);
                                font-size: 24px;
                                font-weight: 300;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                letter-spacing: 5px;
                            }
                        }
                    }

                    .modalView_pop_l_view_b_buyAndTest_b{
                        width: calc(100vw * 433 / 1920);
                        height: 100%;
                        margin-left:-20px;
                        border: 1px solid rgba(123, 229, 255, 1);
                        border-radius: 20px;
                    }

                    .noRightBorder{
                        border-right: none!important;
                    }
                }
            }

            .flex_column{
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);

                .flex_column_title{
                    font-size: 28px;
                    margin-top:24px;
                    line-height: 100%;
                }

                .flex_column_info{
                    font-size: 24px;
                    line-height: 28px;
                }

                .flex_column_info_text{
                    font-size: 16px;
                }

                .flex_column_other_info{
                    font-size: 28px;
                    line-height: 34px;
                    text-indent: 30px;
                    font-weight: 400;
                }

                .flex_column_other_info_text{
                    font-size: 18px;
                    text-indent: 0px;
                    padding-left:33px;
                    font-weight: 400;
                }

                .textIndent46{
                    text-indent: 33px;
                }

                .marginTop24{
                    margin-top: 24px;
                }

                .marginBottom40{
                    margin-bottom: 40px;
                }

                .flex_column_view{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .flex_column_btn{
                        width: 170px;
                        height: 60px;
                        color: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(255, 255, 255, 1);
                        font-size: 24px;
                        font-weight: 300;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        border-radius: 50px;
                        letter-spacing: 5px;
                    }

                    .section-content_2_l_view_t_r{
                        display: flex;
                        margin-left:165px;
                        align-items: center;
                        height: 100%;

                        .section-content_2_l_view_t_r_img{
                            width: 80px;
                            height: 30px;
                            cursor: pointer;
                        }

                        .section-content_2_l_view_t_r_text{
                            font-size: 24px;
                            font-weight: 300;
                            margin-left: 30px;
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }
            }
        }
    }

    .section-content_2_l_other{
        width: 58.92%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .section-content_2_l{
            width: 51.19%;
            height: 100%;
            background: linear-gradient(180deg, #00CDFF 0%, #000000 100%);
            border: 3px solid rgba(123, 229, 255, 1);
            border-radius: 50px;
            box-shadow: 0px -41px 100.5px 0px rgba(0, 205, 255, 1) inset;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &.other{
                width: 100%;
                height: 73.75%;
            }

            .section-content_2_l_view{
                width:90.91%;
                height:100%;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;

                .section-content_2_l_view_t{
                    width: 100%;
                    height: 22.73%;
                    border-bottom: 1px solid rgba(255, 255, 255, 1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .section-content_2_l_view_t_img{
                        width: 85px;
                        height: 87px;
                        margin-bottom: -20px;
                    }

                    .marginRight_26{
                        margin-right: 26px;
                    }

                    .section-content_2_l_view_t_middle{
                        display: flex;
                        flex-direction: column;
                        height: 87px;
                        justify-content: end;
                        font-family:'Inter', sans-serif;
                        color: rgba(255, 255, 255, 1);
                        margin-top: 40px;

                        .section-content_2_l_view_t_middle_title{
                            font-size: 48px;
                            font-weight: 700;
                            line-height: 48px;
                        }

                        .section-content_2_l_view_t_middle_subtitle{
                            font-size: 28px;
                            font-weight: 400;
                        }
                    }

                    .section-content_2_l_view_t_r{
                        display: flex;
                        margin-left:100px;
                        align-items: flex-end;
                        height: 100%;
                        margin-bottom: 30px;

                        .section-content_2_l_view_t_r_img{
                            width: 80px;
                            height: 30px;
                            cursor: pointer;
                        }

                        .section-content_2_l_view_t_r_text{
                            font-size: 24px;
                            font-weight: 300;
                            margin-left: 30px;
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }

                .section-content_2_l_view_t_other{
                    justify-content: flex-start;
                }

                .section-content_2_l_view_b{
                    width: 100%;
                    // height: 245px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    border-radius: 20px;

                    .section-content_2_l_view_b_view{
                        width: 100%;
                        margin: 23px auto 23px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 90.55%;
                        background: rgba(255, 255, 255, 0.15);
                        border-radius: 20px;

                        .modalView_pop_l_view_b_buyAndTest_t{
                            width: calc(100vw * 433 / 1920);
                            height: 100%;
                            background: rgba(255, 255, 255, 0.15);
                            backdrop-filter: blur(12px);
                            box-shadow: 
                                0px 0px 22px 0px rgba(242, 242, 242, 0.5) inset,
                                0px 0px 0px 1px rgba(153, 153, 153, 1) inset,
                                -2px -2px 1px -2px rgba(179, 179, 179, 1) inset,
                                2px 2px 1px -2px rgba(179, 179, 179, 1) inset,
                                3px 3px 0.5px -3.5px rgba(255, 255, 255, 0.5) inset;
                            border-top-left-radius: 20px;
                            border-bottom-left-radius: 20px;                   

                            .modalView_pop_l_view_b_buyAndTest_t_margin{
                                margin: 5.68% 0px 2.38% 7.88%;
                                min-height: 90.55%;
                                height: 90.55%;

                                .modalView_pop_l_view_b_buyAndTest_t_title{
                                    font-size: 36px;
                                    font-weight: 700;
                                    color: rgba(255, 255, 255, 1);
                                    line-height: 36px;
                                }

                                .modalView_pop_l_view_b_buyAndTest_t_price{
                                    font-size: 20px;
                                    color: rgba(255, 255, 255, 1);
                                    height: 48px;
                                    line-height: 25px;
                                    font-family: Inter;
                                    margin-top: 10.62%;

                                    span{
                                        font-weight: 700;
                                        font-size: 32px;
                                    }
                                }

                                .modalView_pop_l_view_b_buyAndTest_t_tiele_text{
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: rgba(255, 255, 255, 1);
                                    // margin-top:30px;
                                    // margin-bottom: 23px;
                                    margin-top: 5.49%;
                                    margin-bottom: 4.21%;
                                    line-height: 26px;
                                    width: 330px;
                                }

                                .marginBottom{
                                    margin-bottom: 23px!important;
                                }

                                .modalView_pop_l_view_b_buyAndTest_t_text{
                                    font-size: 18px;
                                    font-weight: 400;
                                    color: rgba(255, 255, 255, 1);
                                    position: relative;
                                    line-height: 22px;
                                    margin-left: 10px;
                                }

                                .modalView_pop_l_view_b_buyAndTest_t_text::before{
                                    content: "•"; /* 圆点字符 */
                                    position: absolute;
                                    left: -10px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    color: #fff; /* 圆点颜色 */
                                    font-size: 16px; /* 圆点大小 */
                                    line-height: 1;
                                }

                                .modalView_pop_l_view_b_buyAndTest_t_btn{
                                    width: 170px;
                                    height: 60px;
                                    color: rgba(255, 255, 255, 1);
                                    border: 1px solid rgba(255, 255, 255, 1);
                                    font-size: 24px;
                                    font-weight: 300;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    margin-top: 41.92%;
                                    border-radius: 50px;
                                    letter-spacing: 5px;
                                }

                                .modalView_pop_l_view_b_buyAndTest_b_btn{
                                    width: 170px;
                                    height: 60px;
                                    border-radius: 50px;
                                    color: rgba(255, 255, 255, 1);
                                    border: 1px solid rgba(255, 255, 255, 1);
                                    font-size: 24px;
                                    font-weight: 300;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    letter-spacing: 5px;
                                }
                            }
                        }

                        .modalView_pop_l_view_b_buyAndTest_b{
                            width: calc(100vw * 433 / 1920);
                            height: 100%;
                            margin-left:-20px;
                            border: 1px solid rgba(123, 229, 255, 1);
                            border-radius: 20px;
                        }

                        .noRightBorder{
                            border-right: none!important;
                        }
                    }
                }

                .flex_column{
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);

                    .flex_column_title{
                        font-size: 28px;
                        margin-top:24px;
                        line-height: 100%;
                    }

                    .flex_column_info{
                        font-size: 24px;
                        line-height: 28px;
                    }

                    .flex_column_info_text{
                        font-size: 16px;
                    }

                    .flex_column_other_info{
                        font-size: 28px;
                        line-height: 34px;
                        text-indent: 30px;
                        font-weight: 400;
                    }

                    .flex_column_other_info_text{
                        font-size: 18px;
                        text-indent: 0px;
                        padding-left:33px;
                        font-weight: 400;
                    }

                    .textIndent46{
                        text-indent: 33px;
                    }

                    .marginTop24{
                        margin-top: 24px;
                    }

                    .marginBottom40{
                        margin-bottom: 10px;
                    }

                    .fontSize{
                        font-size: 20px;
                        line-height: 22px;
                    }

                    .flex_column_view{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .flex_column_btn{
                            width: 170px;
                            height: 60px;
                            color: rgba(255, 255, 255, 1);
                            border: 1px solid rgba(255, 255, 255, 1);
                            font-size: 24px;
                            font-weight: 300;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            border-radius: 50px;
                            letter-spacing: 5px;
                        }

                        .section-content_2_l_view_t_r{
                            display: flex;
                            margin-left:165px;
                            align-items: center;
                            height: 100%;

                            .section-content_2_l_view_t_r_img{
                                width: 80px;
                                height: 30px;
                                cursor: pointer;
                            }

                            .section-content_2_l_view_t_r_text{
                                font-size: 24px;
                                font-weight: 300;
                                margin-left: 30px;
                                color: rgba(255, 255, 255, 1);
                            }
                        }
                    }
                }
            }
        }

        .section-content_2_l_bottom{
            width: 100%;
            height: 23.62%;
            display: flex;
            border-radius: 50px;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background: linear-gradient(180deg, rgba(0, 192, 255, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
            box-shadow: 0px -30px 85px 0px rgba(0, 192, 255, 1) inset;
            color: #FFFFFF;
            cursor: pointer;

            .section-content_2_m_title{
                font-size: 48px;
                font-weight: 700;
                line-height: 100%;
            }

            .section-content_2_m_text{
                font-size: 32px;
                font-weight: 300;
                line-height: 100%;
                margin-top:20px;
                color: rgba(255, 255, 255, 0.5);
            }
        }
    }

    .section-content_2_m{
        width: 26.78%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        .section-content_2_m_view{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 48.72%;
            border-radius: 50px;
            text-align: center;
            color: rgba(255, 255, 255, 1);

            .section-content_2_m_title{
                font-size: 48px;
                font-weight: 700;
                line-height: 100%;
            }

            .section-content_2_m_text{
                font-size: 32px;
                font-weight: 300;
                line-height: 100%;
                margin-top:40px;
                color: rgba(255, 255, 255, 0.5);
            }
        }

        .section-content_2_m_t{
            background: linear-gradient(180deg, rgba(0, 217, 255, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
            box-shadow: 0px -30px 100px 0px rgba(0, 217, 255, 1) inset;
        }

        .section-content_2_m_b{
            background: linear-gradient(180deg, rgba(0, 192, 255, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
            box-shadow: 0px -30px 100px 0px rgba(0, 192, 255, 1) inset;
        }
    }

    .section-content_2_r{
        width: 19.04%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 177, 255, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
        box-shadow: 0px -30px 100px 0px rgba(0, 177, 255, 1) inset;
        border-radius: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;

        .section-content_2_r_title{
            font-size: 48px;
            font-weight: 700;
            line-height: 100%;
            color: rgba(255, 255, 255, 1);
            margin-top: 40px;
        }

        .section-content_2_r_text{
            font-size: 32px;
            font-weight: 300;
            line-height: 120%;
            color: rgba(255, 255, 255, 1);
            margin-top: 40px;
            width: 291px;
        }
    }

    .modalView_pop_other{
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        position: relative;

        .modalView_pop_other_video{
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: relative;
            z-index: 1;
        }

        .modalView_pop_close{
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 28px;
            color: #fff;
            font-weight: 500;
            cursor: pointer;
            z-index: 2;
        }
    }

    .background_1{
        background: linear-gradient(180deg, rgba(0, 217, 255, 0.7) 0%, rgba(0, 22, 26, 0.7) 100%);
        box-shadow: 0px -50px 100px 0px rgba(0, 217, 255, 1) inset;
    }

    .background_2{
        background: rgba(0, 192, 255, 0.5);
    }

    .background_3{
        background: rgba(0, 177, 255, 0.3);
    }
  }
}
</style>